import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../api/user";
import { toast } from "sonner";

export const useLogin = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: loginUser,
    onSuccess: (data) => {
      // Immediately populate the cache so TransitionScreen/downstream routes
      // see isAuthenticated = true without waiting for a background refetch.
      if (data?.data) {
        queryClient.setQueryData(["current-user"], data.data);
      } else {
        queryClient.invalidateQueries({ queryKey: ["current-user"] });
      }

      const role = data?.data?.role;
      if (role === "admin") {
        navigate("/admin/transition");
      } else {
        // clients users created from the Resources page go directly to /resources
        navigate("/resources");
      }
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || error.message || "Login failed";
      console.error("Login failed:", errorMessage);

      // Show toast notification for wrong credentials
      if (error.response?.status === 401) {
        toast.error("Invalid credentials", {
          description: "The email or password you entered is incorrect. Please try again.",
          duration: 4000,
        });
      } else if (error.response?.status === 404) {
        toast.error("Account not found", {
          description: "No account exists with this email address.",
          duration: 4000,
        });
      } else {
        toast.error("Login failed", {
          description: errorMessage,
          duration: 4000,
        });
      }
    },
  });
};
